import { createContext } from "react";

/**
 * The top-bar DOM node that views portal their action buttons into (pinned
 * views, chart toggle, settings, download). Split into value + setter contexts
 * like view_title: TopHeader registers the node via the stable setter (so it
 * never re-renders when the node changes), and the view reads the node from the
 * value context to portal into it. The buttons stay in the view's React tree —
 * only their DOM position moves — so this adds no re-render coupling.
 */
export const ViewActionsSlotContext = createContext<HTMLElement | null>(null);

export const ViewActionsSlotSetterContext = createContext<
  (el: HTMLElement | null) => void
>(() => {});
